import { FunctionComponent } from 'react';
import ReactConfetti from 'react-confetti';

export const Confetti: FunctionComponent = () => {
  return <ReactConfetti recycle={false} />;
};
